export default __webpack_public_path__ + "static/media/Untitled design (1).d9e240be.png";